import React from 'react';
import styled from 'styled-components';

import { ResponsibleBanner } from 'playup-web-core';

import appConfig from '../../appConfig';
import EighteenPlus from './EighteenPlus';

const showVersion = process.env.REACT_APP_SHOW_VERSION;

const AUFooterNotes: React.FC = () => (
	<div className="_flex md:_justify-between _mt-2 md:_flex-row _flex-col _pb-16 md:_pb-6">
		<div className="_text-xs _flex">
			<EighteenPlus className="_text-light _w-16 _h-16 md:_w-10 md:_h-10" />
			<div className="_flex _flex-col _mx-4 _justify-center">
				<ResponsibleBanner roundBorders />
				<StyledParagraph>
					<StyledLink
						href="https://www.betstop.gov.au"
						title="BetStop"
						target="_blank"
						className="hover:_text-gray-500"
						rel="noreferrer"
					>
						BetStop – the National Self-Exclusion Register
					</StyledLink>{' '}
					is a free service where individuals can register to be excluded from all licensed interactive wagering
					services in a single process
				</StyledParagraph>
				<StyledParagraph>
					For South Australia Residents, {appConfig.brand.name}’s gambling operations are governed by the South
					Australian Gambling{' '}
					<a
						href="https://www.cbs.sa.gov.au/resources/authorised-betting-operations-gambling-code-practice"
						title="Code of Practice"
						target="_blank"
						rel="noopener noreferrer"
						className="hover:_text-gray-500"
					>
						Codes of Practice
					</a>
				</StyledParagraph>
				<p className="_pt-1">
					&copy; {new Date().getFullYear()} {appConfig.brand.name} All bets accepted on behalf of{' '}
					{appConfig.brand.company} Licensed in Northern Territory, Australia by NT Racing Commission
				</p>
			</div>
		</div>
		{showVersion !== `none` && (
			<div className="md:_self-end _text-xs _mt-2 _mr-2 md:_mr-0 lg:_mt-0 _text-right">
				Version {process.env.REACT_APP_VERSION}
			</div>
		)}
	</div>
);

export default AUFooterNotes;

const StyledParagraph = styled.p({
	marginTop: '5px',
	marginBottom: '5px',
});

const StyledLink = styled.a({
	textDecoration: 'underline',
});
